import { IconComponent } from '../icon.types';

export const AttachIcon: IconComponent = (props) => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_397_612)">
      <path
        d="M9.00012 22.6601C6.2144 21.0518 5.25664 17.4774 6.86497 14.6917L11.865 6.03141C13.015 4.03955 15.5649 3.35631 17.5567 4.50631C19.5486 5.65631 20.2318 8.20622 19.0818 10.1981L14.0818 18.8583C13.3943 20.0491 11.8576 20.4609 10.6668 19.7734C9.476 19.0859 9.06422 17.5491 9.75172 16.3583L14.3351 8.41977L15.7784 9.2531L11.1951 17.1917C10.9659 17.5886 11.1032 18.1009 11.5001 18.33C11.897 18.5592 12.4093 18.4219 12.6385 18.025L17.6385 9.36475C18.326 8.17396 17.9142 6.63718 16.7234 5.94968C15.5326 5.26218 13.9958 5.67396 13.3083 6.86475L8.30835 15.525C7.15835 17.5169 7.84159 20.0668 9.83345 21.2168C11.8253 22.3668 14.3752 21.6835 15.5252 19.6917L21.3586 9.58804L22.8019 10.4214L16.9686 20.525C15.3603 23.3107 11.7858 24.2685 9.00012 22.6601Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_397_612">
        <rect
          width="20"
          height="20"
          fill="currentColor"
          transform="translate(10.3397 0.339722) rotate(30)"
        />
      </clipPath>
    </defs>
  </svg>
);
